export const SHOP_URL = "https://consciousness-ascending-shop.fourthwall.com/";
export const SHOP_HOST = "consciousness-ascending-shop.fourthwall.com";

export const IMAGES = {
  hero: "https://static.prod-images.emergentagent.com/jobs/c0ca6640-787c-4fb4-80b8-991fcc863cbf/images/280616e90ac85688bc3e5fed95b91440fd16e1346960eae85ede539621b09d02.jpeg",
  rv: "https://static.prod-images.emergentagent.com/jobs/c0ca6640-787c-4fb4-80b8-991fcc863cbf/images/2c60d7916e5bad9da02a06505290d68b8396c8c58d728409d4f3ab3d8c373f3f.jpeg",
  ap: "https://static.prod-images.emergentagent.com/jobs/c0ca6640-787c-4fb4-80b8-991fcc863cbf/images/e006cc9464ad248b80f87a518a885c50034704193b59125d9a8322d0ffd692f1.jpeg",
  books: "https://static.prod-images.emergentagent.com/jobs/c0ca6640-787c-4fb4-80b8-991fcc863cbf/images/9881029dcfd363f95fa3a5b8738c8fe22b7c23160e9d9d60e256528035eb3e22.jpeg",
  about: "https://static.prod-images.emergentagent.com/jobs/c0ca6640-787c-4fb4-80b8-991fcc863cbf/images/0ec14fdc3c1486f47a2d3ef6c5ebffa3722d8e7079709beee02226bd995f04a2.jpeg",
  shop: "https://static.prod-images.emergentagent.com/jobs/c0ca6640-787c-4fb4-80b8-991fcc863cbf/images/a313683473d1eb2a974bc8dba61c60ebae7081fcd5ab10a67f9f7726bcccdbd7.jpeg",
};

export const NAV_LINKS = [
  { name: "Overview", path: "/", id: "home" },
  { name: "Remote Viewing", path: "/remote-viewing", id: "remote-viewing" },
  { name: "Astral Projection", path: "/astral-projection", id: "astral-projection" },
  { name: "Guidebooks", path: "/guidebooks", id: "guidebooks" },
  { name: "About", path: "/about", id: "about" },
  { name: "FAQ", path: "/faq", id: "faq" },
  { name: "Shop", path: "/shop", id: "shop" },
];

export const RIBBON_ITEMS = [
  "Remote Viewing",
  "Astral Projection",
  "Coordinate Protocols",
  "The Gateway State",
  "Your Own Remote Path",
  "Stargate-Era Discipline",
  "Non-Local Perception",
  "Vibrational Threshold",
];

export const MANIFESTO = [
  {
    chapter: "01",
    title: "Non-local perception is trainable",
    body:
      "Developed through decades of research associated with Stanford Research Institute and Project Stargate, remote viewing treats perception as a protocol: reception that operates outside the ordinary limits of time and distance, practiced step by step.",
  },
  {
    chapter: "02",
    title: "Quiet the overlay, keep the signal",
    body:
      "True non-local perception is not fantasy — it is the disciplined filtering of ego noise, expectation and mental overlay, so that raw signal can be recorded before the analyzing mind names it.",
  },
  {
    chapter: "03",
    title: "Consciousness as architecture",
    body:
      "Astral projection is the deliberate transition from localized somatic reality into subtle environments — through the vibrational threshold, stable focus, and sovereign intent.",
  },
];

export const GUIDEBOOKS = [
  {
    id: "crv-manual-vol-1",
    title: "The CRV Operative Manual: Stages I–III",
    category: "Remote Viewing",
    badge: "Flagship Curriculum",
    coord: "RV·01",
    description:
      "The definitive field manual for Coordinate Remote Viewing. Covers ideogram transcription, sensory matrixing, and AOL filtering — with session worksheets included.",
    format: "Digital Edition + Printable Session Worksheets",
  },
  {
    id: "ap-vibrational-mastery",
    title: "The Vibrational Gateway: Astral Transit Manual",
    category: "Astral Projection",
    badge: "Core Methodology",
    coord: "AP·01",
    description:
      "Mastering the hypnagogic boundary, overcoming the vibrational startle reflex, and executing reliable disembodiment maneuvers.",
    format: "Comprehensive Guide + Audio Cue Companion",
  },
  {
    id: "crv-advanced-vol-2",
    title: "Advanced CRV: Stages IV–VI & Target Verification",
    category: "Remote Viewing",
    badge: "Advanced Practice",
    coord: "RV·02",
    description:
      "Diving into qualitative intelligence, subconscious interrogation, and blind coordinate verification protocols.",
    format: "Masterclass Field Guidebook",
  },
  {
    id: "ap-cartography-higher-planes",
    title: "Cartography of Non-Local Space: Astral Navigation",
    category: "Astral Projection",
    badge: "Navigational Codex",
    coord: "AP·02",
    description:
      "Maps, protective principles, energetic sovereign laws, and interaction protocols across multiple dimensional densities.",
    format: "Hardcover & Digital Codex",
  },
  {
    id: "gateway-unified-workbook",
    title: "The Unified Consciousness Ledger & Daily Drillbook",
    category: "Field Workbooks",
    badge: "Daily Practice",
    coord: "FW·01",
    description:
      "A 120-day structured calibration journal engineered for tracking coordinate hits, sleep metrics, and dream–astral boundary transitions.",
    format: "Spiral Bound Archival Ledger + PDF",
  },
];

export const RV_STAGES = [
  {
    stage: "Stage I",
    name: "Ideograms & Gestalts",
    detail:
      "Spontaneous tactile ink lines capturing the physical archetype of the target — land, water, structure, or energy.",
  },
  {
    stage: "Stage II",
    name: "Sensory Impressions",
    detail:
      "Colors, temperatures, textures, sounds and ambient odors — recorded before the analytical mind names them.",
  },
  {
    stage: "Stage III",
    name: "Spatial & Dimensional Sketches",
    detail:
      "Translating perceptual proportions: height, depth, motion, and the relational geometry of the site.",
  },
  {
    stage: "Stage IV",
    name: "Qualitative & Tangible Data",
    detail:
      "Emotional charges, target concepts and functionality — while labeling and setting aside analytical overlay (AOL).",
  },
  {
    stage: "Stage V",
    name: "Subconscious Interrogation",
    detail:
      "Interrogating the ideogram for subtle vibrational nuance and micro-structure the first pass skipped over.",
  },
  {
    stage: "Stage VI",
    name: "3D Physical & Matrix Modeling",
    detail:
      "Relational matrixing, time tracking, and a comprehensive synthesis of the site layout in three dimensions.",
  },
];

export const AP_PILLARS = [
  {
    step: "01",
    name: "Mind awake, body asleep",
    detail:
      "Calming biological somatic reflexes while maintaining a pin-sharp point of conscious awareness at the hypnagogic boundary.",
  },
  {
    step: "02",
    name: "The vibrational phenomenon",
    detail:
      "Recognizing the internal high-frequency hum — the classic buzzy threshold signal — without panic or cognitive startle.",
  },
  {
    step: "03",
    name: "Separation vectors",
    detail:
      "Employing the roll-out, upward levitation, or portal displacement methods to detach the astral vehicle with intent.",
  },
  {
    step: "04",
    name: "Stabilization & navigation",
    detail:
      "Grounding non-physical vision, demanding clarity on exit, and navigating intentional planes with sovereign composure.",
  },
];

export const FAQ_CATEGORIES = [
  {
    name: "General & Mission",
    faqs: [
      {
        q: "What is the difference between Consciousness Ascending and Your Own Remote Path?",
        a: "Consciousness Ascending is the publishing and educational collective; “Your Own Remote Path” is our educational philosophy and curriculum brand — the idea that you are the sole instrument and investigator of your own awareness.",
      },
      {
        q: "Are these materials scientific or spiritual?",
        a: "Both. We draw on rigorous, declassified protocols derived from documented research programs, while honoring the profoundly transcendental nature of non-physical experience. Discernment is treated as part of the practice, not an afterthought.",
      },
      {
        q: "Which discipline should a beginner start with?",
        a: "We recommend beginning with Remote Viewing Stages I–III if you prefer analytical structure and immediately verifiable feedback. If you are naturally inclined toward meditation and lucid dreaming, Astral Projection offers a more experiential portal. The Guidebooks page lays out both pathways.",
      },
    ],
  },
  {
    name: "Remote Viewing",
    faqs: [
      {
        q: "Do I need natural psychic ability to remote view?",
        a: "No. The protocol was engineered precisely so that ordinary individuals can bypass conscious bias and transcribe subconscious data. Structure — not gift — is the operative variable.",
      },
      {
        q: "What is an Analytical Overlay (AOL)?",
        a: "An AOL occurs when the analytical mind attempts to guess or identify the target (e.g., “looks like a bridge”). In the protocol you label the AOL and move on immediately, preserving the raw signal underneath.",
      },
      {
        q: "Can remote viewing trigger accidental out-of-body travel?",
        a: "No. Remote viewing protocols keep the analytical mind awake and your somatic senses anchored to pen and paper. You remain in the body throughout the session.",
      },
    ],
  },
  {
    name: "Astral Projection",
    faqs: [
      {
        q: "Is astral projection safe? Can I get stuck?",
        a: "You remain tethered to your biological vessel by a subtle energetic connection. The slightest physical stimulus — a sound, a touch, a change in temperature — returns consciousness instantaneously. The manuals cover re-entry thoroughly.",
      },
      {
        q: "How does it differ from lucid dreaming?",
        a: "Lucid dreaming takes place inside an internal, subconscious simulation. Astral projection is practiced as conscious projection into what many traditions describe as an objective non-physical energetic continuum — the manuals teach you to distinguish the two states.",
      },
      {
        q: "What is the vibrational state?",
        a: "It is the classic threshold signal: an internal high-frequency hum or buzz often reported at the edge of sleep. In our materials it is treated as a doorway — the cue to begin separation techniques calmly rather than react with startle.",
      },
    ],
  },
  {
    name: "Guidebooks & Purchasing",
    faqs: [
      {
        q: "Where are guidebooks purchased and fulfilled?",
        a: "All guidebooks, companion materials, and merchandise are fulfilled through our verified Fourthwall storefront at " + SHOP_HOST + " — with worldwide shipping and instant digital downloads.",
      },
      {
        q: "What formats are provided?",
        a: "Depending on the title, items are available as high-resolution interactive PDF, ePub, and museum-quality print editions. Each product page on the storefront lists its exact formats.",
      },
      {
        q: "Do I need anything besides the guidebooks?",
        a: "A pen, unlined paper, a quiet room, and patience with your own mind. Some astral titles suggest headphones for the optional audio cues. Nothing exotic is required.",
      },
    ],
  },
];

export const RV_FAQ = FAQ_CATEGORIES[1].faqs;
export const AP_FAQ = FAQ_CATEGORIES[2].faqs;
